<template>
  <div class="car-list-navbar" :class="{ 'slide-down': showCarListNavMob }">
    <div class="navbar-container">
      <div class="logo">
        <img src="/assets/~/media/images/activity/2026summer/mob/slogan.jpg" alt=""/>
      </div >
      <div class="current-car" @click="showUl">
        <div>{{currrentCarName}}</div>
        <div class="arrow">
          <img src="/assets/~/media/images/activity/2026summer/mob/arrow.png" alt=""/>
        </div>
      </div>
    </div>

    <!-- 下拉列表 -->
    <ul v-show="showCarList">
      <li v-for="(item, index) in carNavbarList" :key="index"
          v-show="item.name !== 'EV6'"
          :class="{ 'li-active': activeItem === index }"
          @click="scrollTo(item,index)"
          :code-stm="`event, PAGEURL, 车型导航点击_${item.name }`" >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      currrentCarName:'',
      clickItem:'',
      clickItemIndex:null,//点击li对应的index
      scrollRangeId:null,//滚动中当前的页面id
      activeItem: '',//active对应的index
      carNavbarList: [
        {id: 'mob1',name:'新狮铂拓界',text:'sportage',index:0},
        {id: 'mob2',name:'2026款 奕跑',text:'kx1',index:1},
        {id: 'mob3',name:'K3',text:'k3',index:2},
        {id: 'mob4',name:'EV5',text:'ev5',index:3},
        {id: 'mob5',name:'EV6',text:'ev6',index:4},
        {id: 'mob6',name:'全新赛图斯',text:'seltos',index:5},
        {id: 'mob7',name:'2026款 嘉华',text:'carnival',index:6},
        {id: 'mob8',name:'K5',text:'k5',index:7},
        {id: 'mob9',name:'智跑',text:'zhipao',index:8},
        {id: 'mob10',name:'索奈',text:'sonet',index:9},
      ],




      lastScrollTop : 0,

      winScroll:0,
      scrollingTimer: null,
      showCarListNavMob:false,
      showCarList:false,
    }
  },
  mounted() {
    // this.calculateSectionPositions();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.updateIsPortrait);
    window.addEventListener('orientationchange', this.updateIsPortrait);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateIsPortrait);
    window.removeEventListener('orientationchange', this.updateIsPortrait);
  },
  methods: {
    updateIsPortrait() {
      this.isPortrait = isPortraitFun();
      if (!this.isPortrait) {
        this.showCarListNavMob = false;
        this.showCarList = false;
      }
    },
    showUl(){
      this.showCarList = !this.showCarList;
    },
    handleScroll() {
      this.winScroll = window.scrollY;
      if (this.isPortrait) {
        this.updateActiveItem();
      }
      //滚动定时器
      if (this.scrollingTimer) {
        clearTimeout(this.scrollingTimer);
      }
      this.scrollingTimer = setTimeout(() => {
        // 用户停止滚动后的操作
        // console.log('用户停止滚动了');
        this.clickItemIndex = null;//清除clickItemIndex
      }, 200);
    },
    updateActiveItem() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // console.log(scrollTop);
      //滑至ev5显示导航栏
      if (scrollTop > window.innerHeight) {
        this.showCarListNavMob = true;
      } else {
        this.showCarListNavMob = false;
      }
      for (let i = 0; i < this.carNavbarList.length; i++) {
        const id = this.carNavbarList[i].id;
        const vh = window.innerHeight;
        const gapVal = vh / 2
        const element = document.getElementById(id);
        if (element) {
          const offset = element.getBoundingClientRect().top + window.scrollY;
          const height = element.offsetHeight;
          if (this.winScroll >= (offset - gapVal) && this.winScroll < (offset + height - gapVal)) {

            if(this.clickItemIndex !== null){//如果是 点击 导致的滚动
              if(this.clickItemIndex !== i){
              }else{
                this.activeItem = i
                this.activeItem = this.clickItemIndex
              }
            }else{
              this.activeItem = i
              this.currrentCarName = this.carNavbarList[i].name
            }
            break;
          }
        }
      }
    },
    scrollTo(item, index) {
      const element = document.getElementById(item.id);
      if (element) {
        const yOffset = -60;//头的高度留出来
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.scrollY + yOffset,
          behavior: 'smooth'
        });
        this.activeItem = index;
        this.clickItemIndex = item.index
        this.currrentCarName = this.carNavbarList[index].name

        this.showCarList = false;
      }
    },

  }
}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
  .car-list-navbar {
    height: 60px;
    width: 100%;
    position: fixed;
    // top: 0;
    top: -100%;
    background-color: #ffffff;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    transition: top 0.5s;
    .navbar-container {
      position: relative;
      width: 100%;
      display:flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 calc(56 / 1125 * 100vw) 0 0;
      .logo {
        height:100%;
        position: absolute;
        left: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: end;
        img {
          /* width: calc(249 / 1125 * 100vw);
          height: calc(88 / 1125 * 100vw); */
          width: 315.82px;
          height: 60px;
        }
      }
      .current-car {
        z-index: 100;
        white-space: nowrap;
        display: flex;
        font-size: calc(42 / 1125 * 100vw);
        .arrow {
          width: calc(29 / 1125 * 100vw);
          height: calc(16 / 1125 * 100vw);
          margin-left: calc(29 / 1125 * 100vw);
        }
      }
    }
    ul {
      position:absolute;
      top: 60px;
      width: 100%;
      max-height: calc((1125 + 80) / 1091 * 100vw);
      padding: calc(34 / 1125 * 100vw) 0;
      background-color: #ffffff;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      li {
        width: 100%;
        cursor: pointer;
        color: #000000;
        /* margin: 0 calc(24 / 1125 * 100vw); */
        font-size: calc(42 / 1125 * 100vw);
        width: 100%;
        padding: calc(34 / 1125 * 100vw) calc(83 / 1125 * 100vw);
        display: flex;
        align-items: center;
        justify-content: start;
        color: grey;
      }
      .li-active {
        color: #000000;
      }

    }

  }
  .slide-down {
    top: 0;
    transition: top 1s;
  }
}

</style>
